export const navigationTabsStyles = {
	tabs: {
		'& .MuiTab-root': {
			textTransform: 'none',
			alignItems: 'flex-start',
			textWrap: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			display: 'block',
			textAlign: 'left'
		},
		'& .MuiTabs-indicator': {
			display: 'none'
		},
		'& .Mui-selected': {
			fontWeight: 700
		}
	},

	tabLink: {
		minHeight: '28px',
		height: '28px',
		textDecoration: 'none',
		borderRadius: 2,
		color: 'text.secondary',
		py: 0.75,
		mb: {
			xs: 0,
			sm: 1
		},
		display: 'flex',
		alignItems: 'center'
	}
};
